import { SearchInput } from '@lmig/lmds-react-alphanumeric-input';
import { IconInfo, IconPhone } from '@lmig/lmds-react-icons';
import { PillButton } from '@lmig/lmds-react-pill-button';
import { Heading } from '@lmig/lmds-react-typography';
import { useUserData } from 'Foundation/User/UserContext';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';
import './WaterMitigation.scss';
import { useState } from 'react';

type Vendor = {
  name: string;
  phone: string;
  recipientID: string;
};

const WaterMitigation = () => {
  const [zip, setZip] = useState<string>();
  const [vendors, setVendors] = useState<Vendor[]>();
  const [invalid, setInvalid] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);
  const { userData } = useUserData();

  const getVendors = async () => {
    setInvalid(false);
    if (zip && zip.match(/^\d{5}(?:[-\s]\d{4})?$/)) {
      setSending(true);
      let data = await fetch(`/api/sitecore/ClaimAsync/WMVendorLookup?zip=${zip}`);
      let obj = await data.json();
      if (obj && obj.vendors)
        setVendors(
          obj.vendors
            .filter((z: any) => z.activeIndicator)
            .map((x: any) => ({
              name: x.vendorName,
              phone: x.vendorPhoneNumber,
              recipientID: x.recipientId,
            })),
        );
      else setVendors([]);
      setSending(false);
    } else {
      setInvalid(true);
    }
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    setInvalid(false);
    if (event.key === 'Enter') getVendors();
  };

  return (
    <>
      <Heading type="h2-light">Water mitigation vendor search</Heading>
      <p className="wm-subtext">
        Using our recommended Water Mitigation Program vendors helps ensure a positive experience for your customers.
      </p>
      <div className="wm-search-box">
        <div>
          {invalid && (
            <p className="wm-input-err">
              <IconInfo size="16" />A valid 5-digit ZIP code is required.
            </p>
          )}
          <SearchInput
            labelVisual="Service area ZIP code"
            onChange={(e) => setZip(e.target.value)}
            value={zip}
            onKeyDown={(e) => onKeyDown(e)}
            onClearClicked={() => {
              setZip('');
              setInvalid(false);
            }}
          />
        </div>
        <PillButton className="wm-search-button" variant="primary" onClick={() => getVendors()}>
          Search
        </PillButton>
      </div>
      {sending ? (
        <CircularProgressSpinner className="wm-spinner" size="64" aria-label="Loading water mitigation vendors..." />
      ) : (
        <div className="wm-results">
          {vendors &&
            vendors.map((vendor: Vendor) => (
              <div className="wm-vendor">
                <Heading type="h4-light">{vendor.name}</Heading>
                <span className="wm-vendor-phone">
                  <IconPhone size="16" />
                  {vendor.phone}
                </span>
                {!userData?.isAgent() ? (
                  <span className="wm-vendor-recipient-id">Recipient ID: {vendor.recipientID}</span>
                ) : (
                  <></>
                )}
              </div>
            ))}
          {vendors && vendors.length == 0 && (
            <p className="wm-no-results-message">
              <IconInfo size="16" /> No vendors were found for that ZIP code. Try searching a nearby or larger ZIP code.
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default WaterMitigation;
